import React, { useState } from "react";
import '../SupplyOrder.css'
import WholesalerDropdown from "../WholesalerDropdown";
import { WHOLESALERS } from "../../../../mock";

const WholesalerDialog = ({ isOpen, onClose, setSelectedWholesaler, handleSubmit }) => {
    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h4>Select Wholesaler</h4>
                <div className="row">
                    {(WHOLESALERS && WHOLESALERS?.length > 0) && <div className="col-md-10 mb-3">
                        <WholesalerDropdown
                            data={WHOLESALERS}
                            setSelectedRecord={(record) => setSelectedWholesaler(record.name)} 
                        />
                    </div>}
                </div>
                <div className="popup-actions">
                    <button onClick={onClose} className="close-btn">Close</button>
                    <button onClick={handleSubmit} className="submit-btn">Submit</button>
                </div>
            </div>
        </div>
    );
};

export default WholesalerDialog;